import React from "react";
import { ArrowUpRight, FileText, Terminal, HardDrive } from "lucide-react";
import { bentoWindows } from "../mock";

const iconFor = (id) => {
  if (id === "equity") return FileText;
  if (id === "newsletter") return Terminal;
  return HardDrive;
};

const BentoWindow = ({ w, className = "" }) => {
  const Icon = iconFor(w.id);
  return (
    <article
      className={`group flex flex-col border-[3px] border-black bg-white shadow-[6px_6px_0px_0px_#000000] transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[10px_10px_0px_0px_#000000] ${className}`}
    >
      {/* Mac-style title bar */}
      <header className="flex items-center gap-2 border-b-[3px] border-black bg-[#E5E5E5] px-3 py-2">
        <span className="h-3 w-3 border-[2px] border-black bg-white" />
        <span className="h-3 w-3 border-[2px] border-black bg-white" />
        <span className="h-3 w-3 border-[2px] border-black bg-[#00FF41]" />
        <span className="ml-2 truncate font-mono text-xs font-bold tracking-wider text-black">
          {w.title}
        </span>
        <span className="ml-auto hidden font-mono text-[10px] font-bold uppercase tracking-widest text-black sm:inline">
          {w.label}
        </span>
      </header>

      <div className="flex flex-1 flex-col gap-5 p-6">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center border-[3px] border-black bg-[#00FF41]">
            <Icon className="h-5 w-5 text-black" strokeWidth={2.5} />
          </div>
          <h3 className="font-heading text-xl font-extrabold leading-tight text-black sm:text-2xl">
            {w.heading}
          </h3>
        </div>

        <p className="font-mono text-sm leading-relaxed text-black">{w.body}</p>

        <div className="mt-auto flex flex-wrap gap-2">
          {w.meta.map((tag) => (
            <span
              key={tag}
              className="border-[2px] border-black bg-white px-2 py-1 font-mono text-[11px] font-bold tracking-wider text-black"
            >
              {tag}
            </span>
          ))}
        </div>

        {w.ctaHref && (
          <a
            href={w.ctaHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-fit items-center gap-2 border-[3px] border-black bg-black px-4 py-2 font-mono text-xs font-bold uppercase tracking-wider text-white shadow-[4px_4px_0px_0px_#00FF41] transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[6px_6px_0px_0px_#00FF41] active:translate-x-[2px] active:translate-y-[2px] active:shadow-[0px_0px_0px_0px_#00FF41]"
          >
            {w.ctaLabel}
            <ArrowUpRight className="h-4 w-4" strokeWidth={3} />
          </a>
        )}
      </div>
    </article>
  );
};

const BentoGrid = () => {
  return (
    <section id="work" className="border-b-[3px] border-black bg-white">
      <div className="mx-auto max-w-7xl px-6 py-16 md:py-24 lg:px-10">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <div className="mb-3 inline-block border-[3px] border-black bg-white px-3 py-1 font-mono text-[11px] font-bold uppercase tracking-widest text-black shadow-[4px_4px_0px_0px_#00FF41]">
              // the 80/20 bridge
            </div>
            <h2 className="font-heading text-4xl font-extrabold leading-tight tracking-tight text-black sm:text-5xl">
              Operations today. <br />
              <span className="bg-[#00FF41] px-2">Research tomorrow.</span>
            </h2>
          </div>
          <p className="max-w-md font-mono text-sm leading-relaxed text-black">
            A snapshot of where I&apos;ve been, what I&apos;m building now, and the academic
            foundation powering the next move.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {bentoWindows.map((w) => (
            <BentoWindow key={w.id} w={w} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BentoGrid;
